const defaultNames = {
  'processmaker-modeler-intermediate-catch-timer-event': 'Intermediate Timer Event',
  'processmaker-modeler-intermediate-signal-catch-event': 'Intermediate Signal Catch Event',
  'processmaker-modeler-intermediate-signal-throw-event': 'Intermediate Signal Throw Event',
  'processmaker-modeler-intermediate-message-catch-event': 'Intermediate Message Catch Event',
  'processmaker-modeler-intermediate-message-throw-event': 'Intermediate Message Throw Event',
  'processmaker-modeler-intermediate-conditional-catch-event': 'Intermediate Conditional Catch Event',
};

export default defaultNames;
